// extracted by mini-css-extract-plugin
export default {"container":"SearchBar_container__fp0Vu","searchWrapper":"SearchBar_searchWrapper__rbKEA","divider":"SearchBar_divider__Z5RG+"};